<div *ngIf="settings" class="container" [ngStyle]="{'background-color': settings.bgColor,
                                   'justify-content': settings.alignment=='start'?'flex-start'
                                                      :settings.alignment=='end'?'flex-end'
                                                      :'center',
                                   'max-width': settings.width
                                  }">
    <div id="wrapper" [ngStyle]="{'padding': settings.spacing}" *ngFor="let tile of tiles; let i = index">
        <div class="tile" 
             [ngStyle]="{
                'border': settings.tileSettings.border,
                'text-transform': settings.tileSettings.uppercase?'uppercase':null,
                'color': selectedId==tile.id ? settings.selectedTileSettings.fontColor
                         : hoverId==tile.id ? settings.hoverTileSettings.fontColor
                         : settings.tileSettings.fontColor,
                'font-size': settings.tileSettings.fontSize,
                'font-weight': settings.tileSettings.fontWeight,
                'border-bottom-color': selectedId==tile.id ? settings.selectedTileSettings.borderBottomColor
                                       : hoverId==tile.id ? settings.hoverTileSettings.borderBottomColor
                                       : null,
                'background-color': selectedId==tile.id ? settings.selectedTileSettings.bgColor 
                                    : hoverId==tile.id ? settings.hoverTileSettings.bgColor 
                                    : settings.tileSettings.bgColor,
                'width': settings.tileSettings.width,
                'height': settings.tileSettings.height,
                'cursor': tile.action ? 'pointer' : null
            }"
            [class.selected]="selectedId==tile.id"
            (click)="select(tile.id); tile.action()"
            (mouseover)="tile.action?hover(tile.id):null"
            (mouseleave)="unhover()">

            <div *ngIf="settings.layout==0" 
                 class="layout1 layout vertical center middle" 
                 style="height: 100%;" >
                <div class="label"
                    [innerHtml]="tile.label | translate"
                    style="text-align: center;"
                    [ngStyle]="{
                        'color': selectedId==tile.id ? settings.selectedTileSettings.label.fontColor
                                : hoverId==tile.id ? settings.hoverTileSettings.label.fontColor
                                : settings.tileSettings.label.fontColor,
                        'font-size': settings.tileSettings.label.fontSize,
                        'font-weight': settings.tileSettings.label.fontWeight,
                        'margin': settings.tileSettings.label.margin,
                        'background-color': selectedId==tile.id ? settings.selectedTileSettings.label.bgColor 
                                            : hoverId==tile.id ? settings.hoverTileSettings.label.bgColor 
                                            : settings.tileSettings.label.bgColor,
                        'width': settings.tileSettings.label.width,
                        'height': settings.tileSettings.label.height,
                        'border-radius': settings.tileSettings.label.borderRadius}" >
                </div>
            </div>

            <div *ngIf="settings.layout==1">
                <div *ngIf="settings.tileSettings.image || settings.tileSettings.icon" 
                     class="layout vertical center middle">
                    <app-icon *ngIf="tile.icon" 
                              [id]="tile.icon" 
                              [settings]="settings.tileSettings.icon">
                    </app-icon>
                    <img *ngIf="tile.imageUrl" 
                         [width]="settings.tileSettings.image.width" 
                         [height]="settings.tileSettings.image.height" 
                         [src]="tile.imageUrl" 
                         [ngStyle]="{'border-radius': settings.tileSettings.image.borderRadius}">
                </div>
                <div *ngIf="tile.label" 
                    [ngStyle]="{
                        'color': selectedId==tile.id ? settings.selectedTileSettings.label.fontColor
                                : hoverId==tile.id ? settings.hoverTileSettings.label.fontColor
                                : settings.tileSettings.label.fontColor,
                        'font-size': settings.tileSettings.label.fontSize,
                        'font-weight': settings.tileSettings.label.fontWeight,
                        'margin': settings.tileSettings.label.margin,
                        'background-color': selectedId==tile.id ? settings.selectedTileSettings.label.bgColor 
                        : hoverId==tile.id ? settings.hoverTileSettings.label.bgColor 
                        : settings.tileSettings.label.bgColor,
                        'width': settings.tileSettings.label.width,
                        'height': settings.tileSettings.label.height,
                        'border-radius': settings.tileSettings.label.borderRadius
                    }" 
                    style="text-align: center" [innerHtml]="tile.label | translate">
                </div>
                <div *ngIf="tile.label2" 
                    [ngStyle]="{
                        'color': selectedId==tile.id ? settings.selectedTileSettings.label2.fontColor
                                : hoverId==tile.id ? settings.hoverTileSettings.label2.fontColor
                                : settings.tileSettings.label2.fontColor,
                        'font-size': settings.tileSettings.label2.fontSize,
                        'font-weight': settings.tileSettings.label2.fontWeight,
                        'margin': settings.tileSettings.label2.margin}"  
                    style="text-align: center" [innerHtml]="tile.label2 | translate">
                </div>
                <div *ngIf="tile.label3" 
                    [ngStyle]="{
                        'color': selectedId==tile.id ? settings.selectedTileSettings.label3.fontColor
                                 : hoverId==tile.id ? settings.hoverTileSettings.label3.fontColor
                                 : settings.tileSettings.label3.fontColor,
                        'font-size': settings.tileSettings.label3.fontSize,
                        'font-weight': settings.tileSettings.label3.fontWeight,
                        'margin': settings.tileSettings.label3.margin}"  
                    style="text-align: left" [innerHtml]="tile.label3 | translate">
                </div>
            </div>
        </div>
    </div>
</div>